import api from '@/utils/api';

/**
 * Get Product Category
 * @param {string} companyId - the companyId
 * @param {string} productId - the productId
 * @returns {Promise}
 */
const getProductCategoryApi = (companyId, productId) =>
  api.get(`/company/${companyId}/product-category/${productId}`);

export default getProductCategoryApi;
